// The possible-connection REVIEW, as a fact the whole box can read (busy-my-web#504, frames
// 40011046:161598 / 40011151:211985).
//
// "View" on a row of components/Email/PossibleConnectionsTable.vue opens one candidate's reasons and
// the Connect / Not related chooser. While that is up, the frames change the universal input under
// it: the placeholder becomes "Ask about this email…" — the box is now about the thing being decided
// — and the bar's primary is the review's own Connect.
//
// The table already knows all of this; SmartBox does not, and the two are not in one component tree
// the box can reach into. So the table PUBLISHES the review here on open and clears it on close, and
// the box reads it. Nothing else: the answer itself (`ongoing/addSuggestedThread` /
// `rejectSuggestedThread`) stays where it was, dispatched by the table, because one component
// deciding is the rule this journey already follows.

export const state = {
  // { id, name, module, ongoingId } while a review is open; null at rest.
  review: null,
}

export const getters = {
  review: s => s.review,
  /** Is a candidate being reviewed right now? — what the placeholder and the CTA are gated on. */
  open: s => !!s.review,
  /** The candidate's name, for anything that wants to say which one ('' at rest). */
  name: s => String(s.review?.name || ''),
}

export const mutations = {
  SET_REVIEW(s, review) { s.review = review || null },
}

export const actions = {
  /** The table opened a review (its "View"). */
  open({ commit }, review) {
    if (!review || !review.id) { commit('SET_REVIEW', null); return null }
    commit('SET_REVIEW', {
      id: String(review.id),
      name: String(review.name || ''),
      module: String(review.module || ''),
      ongoingId: String(review.ongoingId || ''),
    })
    return review.id
  },
  /** …and closed it — answered, backed out of, or the row left the list under it. */
  close({ commit }) { commit('SET_REVIEW', null) },
}
